<script>
  import bus from '@utils/bus'

  export default {
    name: 'list-delete-button',
    props: ['item', 'domain'],
    methods: {
      onDestroy (item) {
        bus.$emit('list-destroy-item', item)
      }
    }
  }
</script>

<template>
    <el-button type="danger"
               v-if="$can(domain + '.destroy')"
               @click="onDestroy(item)"
               title="Remover">
        <i class="fa fa-trash"></i>
    </el-button>
</template>



// WEBPACK FOOTER //
// DeleteButton.vue?656bc567